import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioObjetosContratosService {
  private apiUrl = `${environment.apiUrl}/api/usuario-objetoscontratos`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  getByUsuario(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/usuario/${userId}`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  update(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  asignarObjetos(usuarioId: number, objetoIds: number[]): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/asignar`, { usuarioId, objetoIds }, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  asignarObjetosConDetalle(
    usuarioId: number,
    objetos: Array<{ id: number; isFuec: number; isContrato: number }>
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/asignar`,
      { usuarioId, objetos },
      { withCredentials: true }
    ).pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<never> {
    console.error('Error en UsuarioObjetosContratosService:', error);
    return throwError(() => error);
  }
}
